var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid-view" },
    [
      _c("div", { staticClass: "main-content" }, [
        _c(
          "div",
          { staticClass: "section" },
          [
            _c(
              "el-form",
              {
                staticStyle: { height: "100%" },
                attrs: {
                  "label-width": "50px",
                  "label-position": "right",
                  inline: ""
                }
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("Menu.Search") } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "200px" },
                      attrs: { placeholder: _vm.$t("Menu.SearchTitle") },
                      model: {
                        value: _vm.txtSearch,
                        callback: function($$v) {
                          _vm.txtSearch = $$v
                        },
                        expression: "txtSearch"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-button",
                      {
                        staticStyle: { "margin-left": "5px" },
                        attrs: { type: "primary" },
                        on: { click: _vm.clickQueryHandler }
                      },
                      [_vm._v(_vm._s(_vm.$t("Menu.Search")))]
                    ),
                    _c(
                      "el-button",
                      {
                        staticStyle: { "margin-left": "5px" },
                        attrs: { type: "primary" },
                        on: { click: _vm.addCustomerHandler }
                      },
                      [_vm._v(_vm._s(_vm.$t("Menu.Add")))]
                    ),
                    _c(
                      "el-button",
                      {
                        staticStyle: { "margin-left": "5px" },
                        attrs: { type: "primary" },
                        on: { click: _vm.updateClickHandler }
                      },
                      [_vm._v(_vm._s(_vm.$t("Menu.Update")))]
                    ),
                    _c(
                      "el-button",
                      {
                        staticStyle: { "margin-left": "5px" },
                        attrs: { type: "danger" },
                        on: { click: _vm.onRemove }
                      },
                      [_vm._v(_vm._s(_vm.$t("Menu.delete")))]
                    ),
                    _c(
                      "el-button",
                      {
                        staticStyle: { "margin-left": "5px" },
                        attrs: { type: "primary" },
                        on: { click: _vm.initDataClickHandler }
                      },
                      [_vm._v(_vm._s(_vm.$t("Menu.BasicData")))]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "section grid-wrapper" },
          [
            _c("cargo-ag-grid", {
              attrs: {
                "grid-options": _vm.gridOptions,
                "column-defs": _vm.columnDefs,
                "row-data": _vm.rowData
              },
              on: {
                gridReady: function(params) {
                  _vm.gridApi = params.api
                }
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "pagination-wrapper" },
          [
            _c("cargo-pagination", {
              attrs: {
                "config-module": "9300001",
                total: _vm.total,
                page: _vm.filter.pageNum,
                limit: _vm.filter.pageSize
              },
              on: {
                "update:page": function($event) {
                  return _vm.$set(_vm.filter, "pageNum", $event)
                },
                "update:limit": function($event) {
                  return _vm.$set(_vm.filter, "pageSize", $event)
                },
                pagination: _vm.clickQueryHandler
              }
            })
          ],
          1
        )
      ]),
      _c("tenant-window", {
        attrs: {
          visible: _vm.tenantWindow.visible,
          "is-show-admin": _vm.tenantWindow.isShowAdmin,
          tenant: _vm.tenantWindow.tenant
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.tenantWindow, "visible", $event)
          },
          successCallBack: _vm.clickQueryHandler,
          close: function($event) {
            _vm.tenantWindow.visible = false
          }
        }
      }),
      _c("tenant-standard-window", {
        attrs: {
          visible: _vm.tenantStandardWindow.visible,
          "tenant-obj": _vm.tenantStandardWindow.tenantObj
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.tenantStandardWindow, "visible", $event)
          },
          close: function($event) {
            _vm.tenantStandardWindow.visible = false
          }
        }
      }),
      _c("init-data-window", {
        attrs: {
          visible: _vm.initDataWindow.visible,
          obj: _vm.initDataWindow.obj
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.initDataWindow, "visible", $event)
          },
          close: function($event) {
            _vm.initDataWindow.visible = false
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }